<template>
  <div id="app">
    <div v-if="isShow">
      <tabBar class="head" :num="num" @addWx="addWx"></tabBar>
      <div class="wx_dialog">
        <el-dialog :visible.sync="wxDialog" width="364px">
          <div class="content">
            <div class="img_box">
              <img :src="code_img" alt="" width="100%" height="100%" />
            </div>
            <div class="code_text">
              扫描二维码，添加小助手微信
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
/* eslint-disable */
import tabBar from "./pages/components/tabBar";
export default {
  components: { tabBar },
  name: "App",
  data() {
    return {
      num: 0,
      wxDialog: false,
      code_img: "",
      isShow: false
    };
  },
  mounted() {
    this.num = 1;
    if (
      this.$route.path == "/" ||
      this.$route.path == "/product" ||
      this.$route.path == "/update"
    ) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  },
  watch: {
    $route(to, from, next) {
      if (to.path == "/" || to.path == "/product" || to.path == "/update") {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
      this.num = 0;
      if (to.path == "/update" && from.path == "/product") {
        this.num = 1;
      } else if (to.path == "/product" && from.path == "/update") {
        this.num = 1;
      } else {
        setTimeout(() => {
          this.num = 1;
        });
      }
    }
  },
  methods: {
    addWx(url) {
      this.wxDialog = true;
      this.code_img = url;
      console.log(`123`);
    }
  }
};
</script>

<style lang="scss">

.wx_dialog {
  .content {
    width: 364px;
    height: 360px;
    background-color: #fff;
    overflow: hidden;
    border-radius: 7px;
    .img_box {
      width: 212px;
      height: 212px;
      margin: 54px auto 15px;
    }
    .code_text {
      width: 190px;
      margin: 0 auto;
      text-align: center;
      font-size: 14px;
      font-family: SourceHanSansCN-Normal;
      font-weight: 400;
      color: rgba(128, 124, 124, 1);
    }
  }
}
.wx_dialog /deep/ .el-dialog__header {
  padding: 0;
  height: 0;
}
.wx_dialog /deep/ .el-dialog {
  background-color: transparent;
  border-radius: 8px;
}

.wx_dialog /deep/.el-dialog__body {
  padding: 0;
  background-color: transparent;
  border-radius: 8px;
}
.head {
  position: relative;
  z-index: 999;
}
* {
  margin: 0;
  box-sizing: border-box;
}
body,
html {
  width: 100%;
  height: 100%;
}
#app {
  min-width: 1366px;
  height: 100%;
}
.el-select {
  width: 100% !important;
}
.el-message {
  z-index: 99999 !important;
}
.el-tag.el-tag--info {
  height: 28px !important;
  background: linear-gradient(
    137deg,
    rgba(255, 83, 132, 1) 0%,
    rgba(255, 39, 39, 1) 100%
  );
  border-radius: 8px !important;
  font-size: 14px !important;
  font-family: PingFangSC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: rgba(255, 255, 255, 1) !important;
  line-height: 28px !important;
}
.el-input__inner {
  background: rgba(245, 245, 245, 1) !important;
}
.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  background: rgba(254, 255, 254, 1) !important;
  border-radius: 4px !important;
  border: 1px solid rgba(230, 230, 230, 1) !important;
}
.el-select .el-tag__close.el-icon-close {
  background-color: transparent !important;
  right: -5px !important;
}
.el-tag.el-tag--info .el-tag__close {
  color: #ffffff !important;
  font-size: 16px !important;
}
.el-tag.el-tag--info .el-tag__close:hover {
  background-color: transparent !important;
}
.el-select .el-input.is-focus .el-input__inner {
  background: rgba(254, 255, 254, 1) !important;
  border-radius: 4px !important;
  border: 1px solid rgba(230, 230, 230, 1) !important;
}

// .el-message-box .el-message-box--center {
//   padding: 0;
// }
// .el-message-box__headerbtn {
//   top: 25px;
// }
// .el-message-box__header {
//   padding: 0 !important;
//   height: 60px;
//   border-bottom: 1px solid rgba(230, 230, 230, 1);
//   .el-message-box__title {
//     line-height: 60px;
//     padding-left: 20px;
//   }
// }
// .el-message-box__message {
//   width: 180px;
//   height: 64px;
//   text-align: center;
//   margin: 10px auto;
// }
.is-fullscreen {
  z-index: 9999 !important;
}
.clearfix:before,
.clearfix:after {
  content: "";
  display: table;
}
.clearfix:after {
  clear: both;
}
.clearfix {
  *zoom: 1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue